import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerTypes } from 'src/app/models/servers';
import { requests } from 'src/app/models/requests';

@Injectable()
export class DocsService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.boapi);
  }

  private get ptdeskurl(): string {
    return this.apiService.getCurentServer(ServerTypes.ptdesk);
  }

  public getMedia(id: string): Observable<string> {
    return this.http.get<string>(this.url + 'v1/documents/media/' + id);
  }

  public getPdfMedia(id: string): Observable<Blob> {
    return this.http.get(`${this.url}v1/documents/${id}/media`, { responseType: 'blob' });
  }

  public getDocumentPdf1(mediaId: string, path: string): Observable<string> {
    return this.http.get(`${this.ptdeskurl}/Files/${mediaId}?path=${path}`, { responseType: 'text' });
  }
  
  public getDocumentFieldText(docTenantId: string, documentTypeId: string, fieldId: number): Observable<any> {
    return this.http.get(this.ptdeskurl + '/docs/' + docTenantId + '/documents/'+ documentTypeId + '/fields/'+ fieldId + '/text');
  }

  public getDocumentField(docTenantId: string, documentTypeId: string, fieldId: number): Observable<any> {
    return this.http.get(this.ptdeskurl + '/docs/' + docTenantId + '/documents/'+ documentTypeId + '/fields/'+ fieldId);
  }

  public saveField(docTenantId: string,  fieldId: number, criteriaValue:string, data: any): Observable<any> {
    return this.http.post(this.ptdeskurl + '/docs/' + docTenantId + '/fields/'+ fieldId + '/text/' + criteriaValue, data);
  }
}